import Text from '../../../atoms/Text';

interface IGraphTooltipProps {
  title: string;
  description: string;
  imageUrl?: string;
  height?: number;
}

const GraphTooltip = ({
  title,
  description,
  imageUrl,
  height,
}: IGraphTooltipProps) => {
  return (
    <div className='graph_tooltip' style={{ height }}>
      <Text size={14} className='text--grey-200 text--weight-600'>
        {title}
      </Text>
      <Text size={12} className='text--grey-600 text--weight-500'>
        {description}
      </Text>
      {imageUrl && <img src={imageUrl} className='graph_tooltip__img' />}
    </div>
  );
};

export default GraphTooltip;
